import * as bootstrap from 'bootstrap';

const navbarCollapse = document.getElementById('nav-bar');

document.querySelectorAll('.nav-link').forEach(el => {
    el.addEventListener('click', (e) => {
        const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse)
            || new bootstrap.Collapse(navbarCollapse, { toggle: false });
        bsCollapse.hide();
    })
})